module.exports = __webpack_public_path__ + "img/SeiwaEv-logo-icon.174b4c77.png";